import {
  GET_PROXY_LOGIN_USER_REQUEST,
  GET_PROXY_LOGIN_USER_SUCCESS,
  GET_PROXY_LOGIN_USER_FAILURE,
} from '../../constants/ActionTypes'
import { replace } from "react-router-redux";
import { getUserSuccess, getUserFailure } from "./AccountSetting";
import { loginRedirect, setShowDemoData } from './Signin';
import { ProxyLoginUserApi } from '../api/ProxyLoginUserApi';
import { UsersApi } from '../api/UsersApi';
import { isEnabledDisplayExecutiveList } from '../../utils/planUtils';

export const getProxyLoginUserRequest = (id, token) => ({
  type: GET_PROXY_LOGIN_USER_REQUEST,
  payload: {
    id: id,
    token: token
  }
});

export const getProxyLoginUserSuccess = (user) => ({
  type: GET_PROXY_LOGIN_USER_SUCCESS,
  payload: {
    user: user,
  },
});

export const getProxyLoginUserFailure = (error) => ({
  type: GET_PROXY_LOGIN_USER_FAILURE,
  payload: {
    error: error,
  },
});

export const getProxyLoginUser = (id, token) => {
  return (dispatch, getState) => {
    dispatch(getProxyLoginUserRequest(id, token));
    ProxyLoginUserApi.getProxyLoginUser(id, token, dispatch)
      .then((response) => {
        localStorage.setItem('user', JSON.stringify({ email: response.data.data.email, loginTime: new Date() }));
        dispatch(getProxyLoginUserSuccess(response));

        // TODO バックエンドのUserResourceクラスが重いので改善した方がよい。
        UsersApi.getUser(dispatch)
          .then((response) => {
            const user = response.data.data;
            dispatch(getUserSuccess(user));

            if (!loginRedirect(user, dispatch)) {
              const routerState = getState().router.location.state;
              const from = routerState && routerState.from ? routerState.from.pathname : null;

              // TODO バックエンドからのダミーデータを取得ではなく、フロントのみでダミーデータ表示する処理ができそう。フロントのみで処理ができれば、UserResourceクラスのレスポンスが重い問題を改善できる
              dispatch(setShowDemoData(user));
              if ((user && user.has_letter_orders) || !isEnabledDisplayExecutiveList(user)) {
                dispatch(replace(from ? from : `/order-dashboard`));
              } else {
                dispatch(replace(from ? from : `/executive-list`));
              }
            }
          })
          .catch((error) => {
            dispatch(getUserFailure(error.response));
          });
      })
      .catch((error) => {
        dispatch(getProxyLoginUserFailure(error));
      });
  };
};


// WEBPACK FOOTER //
// ./src/redux/actions/ProxyLoginUser.js